import styled from 'styled-components';
import {fontFamily, fontSize, fontWeight, query, space} from '@theme/fn';

import {font} from '@design/templateFns';
import Stretch from '@components/Layout/Stretch';
import {Block} from '@components/Layout';

import {Breadcrumbs} from '@components/Breadcrumbs';
import {TeamCard, TeamCardProps} from '@components/Card/TeamCard';
import {RenderProseContent} from '@components/PortableText';

import {Staff} from '@schema/types';
import {ResolvedSanityReferences} from '@data/types';

// TYPES
type StaffData = ResolvedSanityReferences<Staff>;

const MappedTeamCard = (block: StaffData) => {
  const props: TeamCardProps = {
    image: block.image,
    phone: block.telephone,
    email: block.email,
    imageAspectRatio: 0.8,
  };

  return <TeamCard {...props} />;
};

// Container
const Container = styled.div`
  display: grid;
  grid-template-gap: 1fr;
  grid-column-gap ${space('lg')};

  @media screen and (${query.atLeast('tablet')}) {
    grid-template-columns: 1fr 400px;
    margin-left: 150px;
    margin-right: 150px;
    grid-column-gap: 200px;
  }
  @media screen and (max-width: 1350px) {
    grid-template-columns: 1fr 350px;
    margin-left: 0px;
    margin-right: 0px;
    grid-column-gap: 50px;
  }
  @media screen and (max-width: 860px) {
    grid-template-columns: 1fr;

  }
`;

const DesktopNameContainer = styled.div`
  display: none;
  @media screen and (${query.atLeast('tablet')}) {
    display: block;
  }
`;

const MobileNameContainer = styled.div`
  display: block;
  @media screen and (${query.atLeast('tablet')}) {
    display: none;
  }
`;

const Name = styled.h2`
  margin-top: 0;
  ${font('headline-xxxl')};
`;

const Title = styled.h3`
  ${font('body-lg-regular')};
  margin-top: 0;
  margin-bottom: ${space('md')};

  @media screen and (${query.atLeast('tablet')}) {
    margin-bottom: ${space('xl')};
    font-size: 22px;
  }
`;

// Back Button
const MoreCTALink = styled.a`
  cursor: pointer;
  text-decoration: none;
  display: flex;
  color: rgba(0, 0, 0, 1);
  font-weight: 700;
  font-size: 14px;
  align-items: center;

  @media screen and (${query.atLeast('desktop')}) {
    font-size: 18px;
  }
`;

const CTAText = styled.div`
  ${font('body-lg-regular')};
  margin-left: ${space('sm')};
`;

// Slugs to use
const teamSlug = '/company/leadership/meet-our-leaders';

const StaffDetailPage = (props) => {
  const {teamDetail} = props;

  // BREADCRUMB DATA
  const pageTitle = `${teamDetail.firstName} ${teamDetail.lastName}`;
  const breadcrumbPages = [
    {
      title: 'Company',
      slug: {current: '/company'},
    },
    {
      title: 'Leadership',
      slug: {current: '/company/leadership'},
    },
    {
      title: 'Meet Our Leaders',
      slug: {current: '/company/leadership/meet-our-leaders'},
    },
    {
      title: pageTitle,
      slug: {current: teamDetail.slug?.current},
    },
  ];

  const nameToDisplay = `${pageTitle}${
    teamDetail.credentials ? `, ${teamDetail.credentials}` : ''
  }`;

  return (
    <>
      <Breadcrumbs pages={breadcrumbPages} />
      {/* <ProseBlock block={page.body} /> */}
      <Block>
        <Container>
          <MobileNameContainer>
            <Name>{nameToDisplay}</Name>
            <Title>{teamDetail.title}</Title>
          </MobileNameContainer>
          <div>
            <DesktopNameContainer>
              <Name>{nameToDisplay}</Name>
              <Title>{teamDetail.title}</Title>
            </DesktopNameContainer>
            <RenderProseContent content={teamDetail.bio} />
          </div>
          <MappedTeamCard {...teamDetail} />
        </Container>
      </Block>
      <Stretch />
    </>
  );
};

export default StaffDetailPage;
